import styled, { keyframes, css } from "styled-components";

const scroll = keyframes`
  from {
    left: 100%;
    transform: translate(0, -50%);
  }
  to {
    left: 0;
    transform: translate(-100%, -50%);
  }
`;

export const MarqueeContent = styled.div<{
  speed: number;
  playing: boolean;
}>`
  // width: max-content;
  white-space: wrap;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  ${(p) =>
    p.playing &&
    css`
      animation: ${scroll} ${(p) => `${p.speed}s`} linear infinite;
    `};
`;

export const MarqueeWrapper = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
`;
